import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { SYSTEM_MODULE } from '../../configs/moduleNames';

export const INIT_APP = 'INIT_APP';
export const SET_LOCALE = 'SET_LOCALE';
export const SET_MENU_STATE = 'SET_MENU_STATE';
export const SHOW_CONFIRM = '_SHOW_CONFIRM';
export const HIDE_CONFIRM = '_HIDE_CONFIRM';
export const START_LOAD_APP = '_START_LOAD_APP';
export const END_LOAD_APP = '_END_LOAD_APP';
export const UPDATE_PERIOD = '_UPDATE_PERIOD';
export const CHECK_SERVICES_AVAILABILITY = '_CHECK_SERVICES_AVAILABILITY';
export const SET_SERVICES_AVAILABILITY = '_SET_SERVICES_AVAILABILITY';

export const initApp = createDeferredAction(SYSTEM_MODULE + INIT_APP);

export const setLocale = createDeferredAction(SYSTEM_MODULE + SET_LOCALE, formValues => (formValues));
export const setMenuState = createDeferredAction(SYSTEM_MODULE + SET_MENU_STATE);
export const showGlobalConfirm = createDeferredAction(SYSTEM_MODULE + SHOW_CONFIRM);
export const hideGlobalConfirm = createAction(SYSTEM_MODULE + HIDE_CONFIRM);
export const startLoadApp = createDeferredAction(SYSTEM_MODULE + START_LOAD_APP);
export const endLoadApp = createAction(SYSTEM_MODULE + END_LOAD_APP);
export const setUpdatePeriod = createAction(SYSTEM_MODULE + UPDATE_PERIOD);
export const checkServicesAvailability = createAction(SYSTEM_MODULE + CHECK_SERVICES_AVAILABILITY);
export const setServicesAvailability = createAction(SYSTEM_MODULE + SET_SERVICES_AVAILABILITY);
